export default __webpack_public_path__ + "static/tools-bb37fdd372f38b41d29024f526a96b6a.png";